import { Component, HostListener, Inject, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core'
import { LayoutService } from '../../core/services/layout.service'
import { ApiService } from '../../core/services/api.service'
import { PageService } from '../../core/services/page.service'
import { ChatState } from '../../core/services/chat.service'
import { ChatService } from '../../core/services/chat.service'
import { SitePage } from '../../site-page/site-page'
import { from } from 'rxjs'
import { IUserReview } from '../../interfaces'
import { mobileErrorMessage, mobileHyphensComplete, sendAppLinkSuccessMessage, validateNumber } from '../../core/helpers/app-link'
import { isPlatformBrowser } from '@angular/common'
import { addFocusOutEventSetInvalid, clickoutCloseInput, removeInvalidOn, setInvalidOn, setMobileAfterChangeAllHyphens } from '../../core/helpers/fields-utils'
import { ActivatedRoute, Router } from '@angular/router'
import { PageNavigationService } from '../../core/services/page-navigation.service'
import { NGXLogger } from 'ngx-logger'
import { SendAppLinkService } from '../../core/services/send-app-link.service'
import { inputAriaCheckActiveState } from '../../core/helpers/inputs-helper'
import { environment } from 'src/environments/environment'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-reason-to-smile',
    templateUrl: './why-us.component.html',
    styleUrls: ['./why-us.component.scss', '../../site-page/site-page.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WhyUsComponent extends SitePage implements OnInit {

  equipmentProviderInActive: boolean;
  hooverPopupText: string
  hooverPopupTextMobile: string
  reviews: IUserReview[] = [ ];
  constructor(private layout: LayoutService,
              private api: ApiService,
              private sendAppLinkService: SendAppLinkService,
              public page: PageService,
              public chatState: ChatState,
              public router: Router,
              route: ActivatedRoute,
              public logger: NGXLogger,
              public sharedDataService: SharedDataService,
              public pageNavigationService: PageNavigationService,
              @Inject(PLATFORM_ID) private platformId: object,
              private chatService: ChatService) {
    super(layout, api.getWhyUsPage(), page, chatState, router, route, pageNavigationService, logger)
  }

  offlinewReviews: IUserReview[] = [
    // {
    //   stars: 5,
    //   title: 'Outstanding!',
    //   text: 'Paying for my dental work just got a lot easier. It’s great having one simple payment.',
    //   consumer: 'Ed'
    //   location: 'Houston'
    // },
      {
        "stars": 5,
        "title": "Smooth process...",
        "text": "Smooth process and clear step by step instructions",
        "consumer": "Kin",
        "location": "Houston"
      },
      {
        "stars": 5,
        "title": "It’s so EASY...",
        "text": "Getting approved took no time at all. It was so straight forward!",
        "consumer": "Jeffery",
        "location": "Atlanta"
      },
      {
        "stars": 5,
        "title": "They take the time to explain...",
        "text": "They explain everything and help make you feel comfortable",
        "consumer": "Brenda",
        "location": "Glenside"
      }
   ]


  onMobileInput(e) {
    mobileHyphensComplete(e, e.target)
  }

  getTrustpilot() {
    this.api.getTrustpilotReviews().subscribe(res => {
      this.reviews = res.reviews
        .filter(x => x.status === 'active')
        .map(x => {
          // IUserReview
          return {
            stars: x.stars,
            text: x.text,
            title: x.title,
            consumer: x?.consumer?.displayName,
            location: x?.consumer?.displayLocation
          }
        })
      // this.reviews = res
    }, (error: any) => {
      console.error(error)
    })
  }

  ngOnInit() {
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
    if(this.equipmentProviderInActive){
      this.reviews = this.offlinewReviews;
    }else {
      this.getTrustpilot()
    }
  
    setTimeout(() => {
      // client code
      if (isPlatformBrowser(this.platformId)) {
        this.loadTrustpilot()
      }
    }, 300)
    setTimeout(() => {
      if (this.api.modalPopupText) {
        this.hooverPopupText = this.api.modalPopupText
      }
      if (this.api.modalPopupTextMobile) {
        this.hooverPopupTextMobile = this.api.modalPopupTextMobile
      }
      // client code
      if (isPlatformBrowser(this.platformId)) {
        setMobileAfterChangeAllHyphens('appLinkInputMobile')
        addFocusOutEventSetInvalid('appLinkInputMobile', 'appLinkInputModalDiv', validateNumber)
      }
    }, 1000)


    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
  }


  loadTrustpilot() {
        if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const trustbox1 = document.getElementById('trustbox1')
    if (trustbox1) {
      (window as any).Trustpilot.loadFromElement(trustbox1)
    }
    const trustbox2 = document.getElementById('trustbox2')
    if (trustbox2) {
      (window as any).Trustpilot.loadFromElement(trustbox2)
    }
  }

  sendChatQuestion() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const el = document.querySelector('#chatI') as any
    if (el?.value && el?.value !== '') {
      if (this.chatState.state.isChatOpened) {
        return
      }
      this.chatState.initActivity(el.value)
      this.chatState.toggleChat(true)
    }
  }

  sendAppLinkEvent(event) {
        if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const targetDivId = 'appLinkInputModalDiv'
    const numbr = (document.getElementById('appLinkInputMobile') as any).value
    this.logger.info(numbr)
    this.logger.info(event)
    if (!validateNumber(numbr)) {
      this.logger.info('send notify')
      setInvalidOn(targetDivId)
      // this.notifier.notify('error', mobileErrorMessage)
      return
    }
    removeInvalidOn(targetDivId)
    this.sendAppLinkService.sendAppLinkWrapper(null, numbr, null)
  }

  inputItemClick(event: any): void
  {
    inputAriaCheckActiveState(event.currentTarget)
  }


  @HostListener('document:click', ['$event'])
  clickout(event) {
    clickoutCloseInput(event)
  }

}
